export function money(n: number, decimals = 2): string {
  return Number(n).toLocaleString("en-US", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
}

export function signedMoney(n: number, decimals = 2): string {
  const value = money(Math.abs(n), decimals);
  return `${n >= 0 ? "+" : "-"}${value}`;
}

export function signedPercent(n: number): string {
  return `${n >= 0 ? "+" : ""}${n.toFixed(2)}%`;
}
